import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["zoomableContainer"]

  connect() {
    this.scale = 1.0

    var scrollToPageNumber = this.element.getAttribute("data-scroll-to-page-number");
    if (scrollToPageNumber) {
      document.querySelector("[data-page-number='" + scrollToPageNumber + "']").scrollIntoView();
    }
  }

  zoomIn(e) {
    e.preventDefault()
    this.scale += 0.2
    this.zoom()
  }

  zoomOut(e) {
    e.preventDefault()
    if (this.scale <= 1.0) {
      return false
    }

    this.scale -= 0.2
    this.zoom()
  }

  zoom() {
    this.zoomableContainerTarget.style.transform = "scale(" + this.scale + ")"
    return false
  }

}